module.exports = __webpack_public_path__ + "img/9-1.4fb11e2c.jpg";